export const ANALYTICS_CONSENT_KEY = "ss_analytics_consent";
export const ANALYTICS_CONSENT_EVENT = "ss-analytics-consent";
export const ANALYTICS_PREFERENCES_EVENT = "ss-analytics-preferences";

export type AnalyticsConsent = "accepted" | "declined" | null;

export const getAnalyticsConsent = (): AnalyticsConsent => {
  const stored = localStorage.getItem(ANALYTICS_CONSENT_KEY);
  return stored === "accepted" || stored === "declined" ? stored : null;
};

export const setAnalyticsConsent = (value: Exclude<AnalyticsConsent, null>) => {
  localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  window.dispatchEvent(new Event(ANALYTICS_CONSENT_EVENT));
};

export const openAnalyticsPreferences = () => {
  window.dispatchEvent(new Event(ANALYTICS_PREFERENCES_EVENT));
};

export const applyAnalyticsConsent = (value: AnalyticsConsent) => {
  const w = window as typeof window & {
    posthog?: { opt_in_capturing?: () => void; opt_out_capturing?: () => void };
  };

  if (!value) return;

  // Only control PostHog - Matomo is loaded elsewhere when consent is accepted.
  if (value === "accepted") {
    w.posthog?.opt_in_capturing?.();
  } else {
    w.posthog?.opt_out_capturing?.();
  }
};
